











import Vue from "vue";
import Component from "vue-class-component";
import parkingRepository from "@/data/parkingRepository";
import { globalState } from "@/globalState";
import ParkingInfo from "@/components/ParkingInfo.vue";

@Component({
  components: {
    ParkingInfo
  }
})
export default class ParkingStats extends Vue {
  isDestroyed = false;

  mounted() {
    this.updateStats();
  }

  destroyed() {
    this.isDestroyed = true;
  }

  get stats() {
    return globalState.parkingStats;
  }
  
  get statsTime() {
    return globalState.parkingStatsUpdateTime;
  }

  updateStats() {
    parkingRepository
      .getStats()
      .then(res => {
        globalState.updateStats(res);
      })
      .finally(() => {
        if (this.isDestroyed) return;

        setTimeout(() => this.updateStats(), 1000);
      });
  }
}
